// eslint-disable-next-line @typescript-eslint/naming-convention
import React from 'react';
import { Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { SurveyImageAnnotation } from './Surveys/SurveyImageAnnotation';
import { getParameterByName } from './utils/getParameterByName';

export function ImageAnnotation() {
    const objectId = getParameterByName('objectid');
    const assetId = getParameterByName('assetid');
    const surveyId = getParameterByName('surveyid');
    const useSmallFont = getParameterByName('small') === 'true';

    if (!assetId) {
        return null;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path="/annotation.html"
                    element={<SurveyImageAnnotation objectId={objectId} assetId={assetId} surveyId={surveyId} smallFont={useSmallFont} />}
                />
            </Routes>
        </BrowserRouter>
    );
}
